module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.showProductDetails()
      }
    }
  }, [(_vm.wdtype == 'lostBuybox' && _vm.item.statusDetails && _vm.item.statusDetails.message && _vm.item.statusDetails.message.indexOf('no offers from any sellers') >= 0) ? _c('i', {
    class: 'right grey warning circle big icon'
  }) : _c('i', {
    class: 'right ' + (_vm.item.issueStatus > 0 && (_vm.item.status == 1 || _vm.item.status == 2) ? 'blue' : _vm.itemprops.listcolor[_vm.item.status]) + ' ' + _vm.itemprops.listicon + ' big icon'
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.date !== null),
      expression: "item.date !== null"
    }],
    staticClass: "ui basic top right attached label"
  }, [_vm._v("\n    " + _vm._s((new Date(_vm.item.date)).toLocaleDateString('en-US')) + "\n    "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n      " + _vm._s((new Date(_vm.item.date)).toLocaleTimeString('en-US')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.detSel == 'wd' && _vm.item.productId !== null && _vm.imageLoaded) ? _c('img', {
    staticClass: "left floated small ui image",
    staticStyle: {
      "max-width": "110px",
      "max-height": "110px",
      "width": "auto",
      "height": "auto",
      "border-radius": "2px"
    },
    attrs: {
      "src": _vm.$parent.$parent.$parent.worldStore.products[_vm.item.productId].largeImageUrl
    }
  }) : (_vm.detSel == 'wd' && _vm.item.productId !== null) ? _c('div', {
    staticClass: "left floated small ui image",
    staticStyle: {
      "width": "110px",
      "height": "110px",
      "background": "#f5f5f5",
      "border-radius": "2px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('i', {
    staticClass: "grey image icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.item.productId !== null || _vm.item.productGroupId !== null || _vm.item.marketplace !== null) ? _c('div', {
    staticClass: "ui left floated basic segment description",
    staticStyle: {
      "width": "19%",
      "max-height": "113px",
      "padding": "0",
      "margin": "0",
      "overflow": "hidden",
      "text-overflow": "clip"
    }
  }, [(_vm.item.productId !== null || _vm.item.productGroupId !== null) ? _c('span', [_c('i', {
    class: _vm.getMarketplaceFlag(_vm.item)
  }), _vm._v(" "), (_vm.groupByParent && _vm.item.productGroupProductIds && _vm.item.productGroupProductIds.length > 1) ? _c('span', {
    staticClass: "ui mini circular grey label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    },
    attrs: {
      "data-content": _vm.item.productGroupProductIds.length + ' variations in this group',
      "data-position": "top left",
      "data-variation": "mini"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.item.productGroupProductIds.length) + "\n        ")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.getProductTitle(_vm.item.productId)) + "\n      ")]) : (_vm.item.marketplace && _vm.item.sellerId && _vm.$parent.$parent.$parent.worldStore.sellerAccounts[_vm.item.sellerId]) ? _c('div', {
    staticStyle: {
      "padding-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.$parent.$parent.$parent.worldStore.sellerAccounts[_vm.item.sellerId].accountNickName) + " - " + _vm._s(_vm.item.marketplace) + " marketplace")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui right floated basic segment header",
    style: ('width:' + (_vm.item.productId !== null ? '58' : '80') + '%; padding:0; margin:0; font-size:16px;')
  }, [(_vm.wdtype == 'salesDrop') ? _c('img', {
    staticClass: "right floated small ui image",
    attrs: {
      "src": '/api/sentinel/watchdog/salesdropchart/' + _vm.item.watchDogId
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$parent.$parent.$parent.$refs.chartModal.open(_vm.$parent.$parent.$parent.worldStore.products[_vm.item.productId], null)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [(_vm.item.muted) ? _c('i', {
    staticClass: "blue mute alarm outline icon"
  }) : _vm._e()]), _vm._v(" "), ((_vm.item.status === 1 || _vm.item.status === 2) && !_vm.item.muted) ? _c('span', [(_vm.item.issueStatus == 1) ? _c('span', {
    staticClass: "ui tiny circular blue label",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "5px"
    }
  }, [_c('i', {
    staticClass: "ui inverted blue unhide icon",
    staticStyle: {
      "margin-right": "3px"
    }
  }), _vm._v("Seen")]) : (_vm.item.issueStatus == 2) ? _c('span', {
    staticClass: "ui tiny circular blue label",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "5px"
    }
  }, [_c('i', {
    staticClass: "ui inverted blue time  icon",
    staticStyle: {
      "margin-right": "3px"
    }
  }), _vm._v("In Progress")]) : (_vm.item.issueStatus == 3) ? _c('span', {
    staticClass: "ui tiny circular blue label",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "5px"
    }
  }, [_c('i', {
    staticClass: "ui inverted blue check icon",
    staticStyle: {
      "margin-right": "3px"
    }
  }), _vm._v("Done")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.wdtype == 'badReview' || _vm.wdtype == 'topReview') ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prettyfyReviewText(_vm.item.statusDetails.message))
    }
  }) : (_vm.wdtype == 'starRatingRecentChange') ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prettyfyRatingText(_vm.item.statusDetails.message))
    }
  }) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.item.statusDetails.message)
    }
  }), _vm._v(" "), (_vm.wdtype != 'listingSuspended') ? _c('div', {
    staticClass: "description issueStatusButton",
    staticStyle: {
      "margin-top": "35px",
      "position": "relative"
    }
  }, [(_vm.item.productId !== null && _vm.wdtype != 'badReview' && _vm.wdtype != 'topReview') ? _c('a', {
    staticClass: "ui tiny orange basic compact icon button",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "target": "_blank",
      "href": _vm.$parent.$parent.$parent.worldStore.products[_vm.item.productId].productUrl
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "icon external share"
  }), _vm._v("View on Amazon")]) : (_vm.item.productId !== null && _vm.wdtype == 'badReview') ? _c('a', {
    staticClass: "ui tiny orange basic compact icon button",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "target": "_blank",
      "href": _vm.$parent.$parent.$parent.worldStore.products[_vm.item.productId].productReviewsUrl
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "icon external share"
  }), _vm._v("Latest Reviews")]) : (_vm.item.productId !== null && _vm.wdtype == 'topReview') ? _c('a', {
    staticClass: "ui tiny orange basic compact icon button",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "target": "_blank",
      "href": _vm.$parent.$parent.$parent.worldStore.products[_vm.item.productId].productTopReviewsUrl
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "icon external share"
  }), _vm._v(" Top Rated Reviews")]) : (_vm.wdtype == 'badSellerFeedback') ? _c('a', {
    staticClass: "ui tiny orange basic compact icon button",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "target": "_blank",
      "href": _vm.$parent.$parent.$parent.worldStore.sellerAccounts[_vm.item.sellerId].feedbackUrls[_vm.item.marketplace]
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "icon external share"
  }), _vm._v("View on Amazon")]) : _vm._e(), _vm._v(" "), _c('span'), _vm._v("\n          \n\n        "), _vm._v(" "), ((_vm.item.status === 1 || _vm.item.status === 2) && !_vm.item.muted) ? _c('span', {
    staticClass: "issueStatusButton",
    staticStyle: {
      "position": "absolute",
      "top": "-20px",
      "font-size": "11px"
    }
  }, [_c('i', {
    staticClass: "grey book icon",
    staticStyle: {
      "margin-right": "1px"
    }
  }), _vm._v("Issue Status\n          ")]) : _vm._e(), _vm._v(" "), ((_vm.item.status === 1 || _vm.item.status === 2) && !_vm.item.muted) ? _c('div', {
    staticClass: "ui tiny basic blue compact buttons issueStatusButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [(_vm.item.issueStatus == 0) ? _c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(1)
      }
    }
  }, [_vm._v("Mark as Seen")]) : _vm._e(), _vm._v(" "), (_vm.item.issueStatus == 1) ? _c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(2)
      }
    }
  }, [_vm._v("Mark as In Progress")]) : _vm._e(), _vm._v(" "), (_vm.item.issueStatus == 2) ? _c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(3)
      }
    }
  }, [_vm._v("Mark as Done")]) : _vm._e(), _vm._v(" "), (_vm.item.issueStatus == 3) ? _c('div', {
    staticClass: "ui disabled button"
  }, [_vm._v("Mark as ➔")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui top right pointing dropdown icon button"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "small menu"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "margin-top": "9px"
    }
  }, [_vm._v("Mark issue as ...")]), _vm._v(" "), (_vm.item.issueStatus != 0) ? _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(0)
      }
    }
  }, [_c('i', {
    staticClass: "hide icon"
  }), _vm._v(" New")]) : _vm._e(), _vm._v(" "), (_vm.item.issueStatus != 1) ? _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(1)
      }
    }
  }, [_c('i', {
    staticClass: "unhide icon"
  }), _vm._v(" Seen")]) : _vm._e(), _vm._v(" "), (_vm.item.issueStatus != 2) ? _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(2)
      }
    }
  }, [_c('i', {
    staticClass: "time icon"
  }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (_vm.item.issueStatus != 3) ? _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(3)
      }
    }
  }, [_c('i', {
    staticClass: "check icon"
  }), _vm._v(" Done")]) : _vm._e()])])]) : _vm._e(), _vm._v("\n          \n\n        "), _vm._v(" "), (!_vm.item.muted) ? _c('div', {
    staticClass: "ui tiny basic compact button issueStatusButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui top right pointing dropdown"
  }, [_c('span', {
    attrs: {
      "data-html": 'Mute this alert type' + (_vm.$parent.accountLevelWd ? '' : ('<br>for this product ' + (_vm.groupByParent && _vm.item.productGroupProductIds && _vm.item.productGroupProductIds.length > 1 ? 'and variations' : ''))),
      "data-variation": "mini",
      "data-position": "right center"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$parent.accountLevelWd ? 'Mute' : 'Mute Product...') + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "small menu"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "margin-top": "9px"
    }
  }, [_vm._v("Mute for ...")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24)
      }
    }
  }, [_vm._v("24h")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24 * 3)
      }
    }
  }, [_vm._v("3 days")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24 * 7)
      }
    }
  }, [_vm._v("1 week")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24 * 14)
      }
    }
  }, [_vm._v("2 weeks")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24 * 30)
      }
    }
  }, [_vm._v("1 month")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24 * 61)
      }
    }
  }, [_vm._v("2 months")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24 * 999)
      }
    }
  }, [_vm._v("Until I turn it back on")])])])]) : _vm._e(), _vm._v(" "), (_vm.item.muted) ? _c('a', {
    staticClass: "ui tiny basic label",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.muteItem(-1)
      }
    }
  }, [_vm._v("Un-mute")]) : _vm._e(), _vm._v(" "), (_vm.$parent.$parent.$parent.onboarding.issuestatus && _vm.itemtype === 'red') ? _c('div', {
    staticClass: "onboarding ui up pointing large yellow label",
    staticStyle: {
      "margin": "10px 0 0 40px"
    },
    attrs: {
      "data-onboarding": "issuestatus"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_vm._v("\n          Mark as Seen - This is very useful!"), _c('br'), _vm._v(" "), _c('small', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("Click [Mark as Seen] to dismiss these notes")])]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-772b57cf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WatchdogItem.vue
// module id = 793
// module chunks = 2